// Adding all the comonly used string manipulation functions here
import { NAVIGABLE_PATHS } from '../../../core/constants';
import { ExcludeParamKeys } from '../constants';

export const hasValue = (str: string) => (
  str !== null && str !== undefined && str.length > 0
);

export const buildSearchParams = (params: object): string => {
  let searchParams = '';

  for (const [key, value] of Object.entries(params)) {
    if (!value || ExcludeParamKeys.includes(key)) {
      continue;
    }

    if (Array.isArray(value)) {
      for (const el of value) {
        searchParams += `${key}=${encodeURIComponent(String(el))}&`;
      }
      continue;
    }

    if (key) {
      searchParams += `${key}=${encodeURIComponent(String(value))}&`;
    }
  }

  return searchParams.replace(/.$/g, '');
};

export const isValidString = (value: any) =>
  typeof value === 'string' && value.trim().length > 0;

export const isValidArray = (value: any) =>
  Array.isArray(value) && value.length > 0;

export const formatNumberUS = (value?: number, options?: Intl.NumberFormatOptions) => {
  if (value === null || value === undefined) {
    return 'N/A';
  }

  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
    ...options
  }).format(value);
};

export const ENDPOINT_TO_TAB_NAME: Record<string, string> = Object.fromEntries(
  Object.entries(NAVIGABLE_PATHS).map(([tabName, endpoint]) => [endpoint, tabName])
);

